import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
// import Header from "../../components/Header";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isNullOrUndefined } from "../../utils/utils";
import { StaticRouterLinks } from "../../utils/StaticRouterLinks";
import { ImageSrc } from "../../utils/ImageSrc";

export default function SignInLayout() {
  const navigate = useNavigate();
  let location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (!isNullOrUndefined(localStorage.getItem("token"))) {
      if (!isNullOrUndefined(queryParams)) {
        navigate(StaticRouterLinks?.document + `?${queryParams.toString()}`, {
          replace: true,
        });
        if (
          queryParams.has("status") &&
          queryParams.get("status") === "success"
        ) {
          localStorage.removeItem("token");
        }
      } else
        navigate(StaticRouterLinks?.document, {
          replace: true,
        });
    }
    if (!isNullOrUndefined(queryParams.get("token"))) {
      localStorage.setItem("token", queryParams.get("token"));

      if (!isNullOrUndefined(queryParams))
        navigate(StaticRouterLinks?.document + `?${queryParams.toString()}`, {
          replace: true,
        });
      else
        navigate(StaticRouterLinks?.document, {
          replace: true,
        });
    }
  }, []);
  return (
    <>
      <div
        className={`${
          location?.pathname === "/" ? "hidden" : "block"
        } lg:hidden w-full bg-white`}
      >
        {/* <Header /> */}
      </div>

      <div
        className={`flex flex-col lg:flex-row justify-center items-center w-screen h-screen  lg:pkt-pkt-primary `}
      >
        <div className="flex flex-col lg:flex-row basis-[100%] lg:basis-[75%] w-[100%] max-w-[1205px] h-[100%] lg:h-[86%] lg:max-h-[798px] overflow-hidden lg:rounded-[29px] lg:shadow-[0_0px_74px_8px_rgba(10,0,29,0.10)]">
          <div
            className={`flex lg:flex flex-col justify-center items-center gap-8 pl-4 lg:pl-14 pt-12 relative basis-[41%] lg:basis-3/5 bg-pkt-secondary`}
          >
            <img
              src={ImageSrc?.headerImages?.pace}
              alt="pace-logo-header"
              className="w-[300px]"
            />

            <span className="text-[40px] font-bold text-pkt-primary">
              Account Closure
            </span>
          </div>
          <div
            className={`flex flex-row justify-center   ${
              location?.pathname === "/"
                ? "items-center basis-[59%]"
                : "items-start basis-[100%] "
            } lg:items-center  lg:basis-2/5 z-10 rounded-t-[10px] lg:rounded-t-[0px]  bg-white relative`}
          >
            <ToastContainer
              position="bottom-center"
              autoClose={3000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss={false}
              draggable
              pauseOnHover
              closeButton={false}
              transition={Bounce}
              limit={1}
              className="pkt-position-absolute pkt-bottom-percentage-10"
            />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
